"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListChildren = void 0;
var _react = require("react");
var _debounce = _interopRequireDefault(require("lodash/debounce"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var emptyArr = [];
var useListChildren = function useListChildren(items) {
  var isShowAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _useState = (0, _react.useState)(items),
    _useState2 = _slicedToArray(_useState, 2),
    visibleChildren = _useState2[0],
    setVisibleChildren = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    hiddenChildren = _useState4[0],
    setHiddenChildren = _useState4[1];
  var outerDivRef = (0, _react.useRef)(null);
  var extraRef = (0, _react.useRef)(null);
  var contentRef = (0, _react.useRef)(null);
  var setListChildren = (0, _react.useCallback)(function () {
    if (isShowAll) {
      setVisibleChildren(items);
      setHiddenChildren(emptyArr);
    } else if (outerDivRef.current && contentRef.current) {
      var outerRect = outerDivRef.current.getBoundingClientRect();
      var children = Array.from(contentRef.current.querySelectorAll('[data-is-visible=true]'));
      var menuWidth = 0;
      if (extraRef.current) {
        menuWidth = extraRef.current.getBoundingClientRect().width;
      }
      var childrenTotalWidth = children.reduce(function (totalWidth, child) {
        return totalWidth + child.getBoundingClientRect().width;
      }, 0);
      if (childrenTotalWidth > outerRect.width - menuWidth) {
        var tempVisibleChildren = _toConsumableArray(visibleChildren);
        var tempHiddenChildren = _toConsumableArray(hiddenChildren);
        var child = tempVisibleChildren.pop();
        if (child) {
          tempHiddenChildren.unshift(child);
        }
        setVisibleChildren(tempVisibleChildren);
        setHiddenChildren(tempHiddenChildren);
      }
    }
  }, [hiddenChildren, isShowAll, items, visibleChildren]);
  var getChildHeight = function getChildHeight() {
    if (contentRef.current) {
      var children = Array.from(contentRef.current.children);
      return children[0].getBoundingClientRect().height;
    }
  };
  (0, _react.useEffect)(function () {
    var debounced = (0, _debounce.default)(function () {
      setVisibleChildren(items);
      setHiddenChildren([]);
    }, 200);
    debounced();
    window.addEventListener('resize', debounced);
    return function () {
      window.removeEventListener('resize', debounced);
    };
  }, [items]);
  (0, _react.useEffect)(function () {
    if (visibleChildren.length) {
      setListChildren();
    }
  }, [setListChildren, visibleChildren.length]);
  return {
    outerDivRef: outerDivRef,
    contentRef: contentRef,
    extraRef: extraRef,
    visibleChildren: visibleChildren,
    setVisibleChildren: setVisibleChildren,
    hiddenChildren: hiddenChildren,
    setHiddenChildren: setHiddenChildren,
    getChildHeight: getChildHeight
  };
};
exports.useListChildren = useListChildren;